import type { FaireProductEntity } from "../../entity_types/product";

export const p_694kz6jnqt: FaireProductEntity = {
  token: "p_694kz6jnqt",
  type: "product",
  name: "Ouija Board Mystifying Mints Candy Tin, 18ct",
  brandToken: "b_ayvwhzhr3m",
  brandName: "Grandpa Joe's Candy Shop",
  imageUrl:
    "https://cdn.faire.com/fastly/d97e4f996d39dfb30e7998b77bc3143fe4de847934799a5a1ee6e1ed3a563310.jpeg",
  galleryImageUrls: [],
  priceDollars: 1.89,
  description:
    "Ouija Board Mystifying Mints Candy Tin, 18ct\n\nUnlock a little mystery with the Ouija Mystifying Mints Candy Tin! Inspired by the iconic Ouija board, this collectible tin is the perfect spooky-season treat for Halloween displays, horror fans, and lovers of the supernatural. Each reusable tin is filled with refreshing mint candies, making it a fun keepsake long after the candy is gone.\n\nPerfect for checkout counters, Halloween gift baskets, haunted house concessions, and impulse purchases, this officially licensed collectible combines nostalgic horror with a refreshing minty treat.\n\nWhy Customers Love It:\n\nOfficial Ouija collectible candy tin\nFilled with refreshing mint candies\nReusable collectible tin featuring classic Ouija board artwork\nGreat for Halloween, horror fans, party favors, and gift baskets\nEye-catching impulse item for seasonal displays\n\nProduct Details:\n\n18 Count Retail Ready Display\nCollectible Reusable Tin\nRefreshing Mint Candies\nOfficially Licensed Ouija Product\nPerfect for Halloween and year-round horror collectibles\nA Treat with a Mysterious Twist\n\nWhether you're summoning spirits or simply satisfying your sweet tooth, the Ouija Mystifying Mints Candy Tin is a hauntingly fun collectible. With classic Ouija-inspired artwork and refreshing mint candies inside, it's the perfect addition to any Halloween candy assortment or horror collection. 👻🖤🪦🍬",
  tags: [],
  msrpDollars: 3.78,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:33.397Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
